import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminSectionNav.css';

function AdminSectionNav() {
  return (
    <nav className="canvas-admin-section-nav" aria-label="管理页面导航">
      <NavLink exact to="/admin/canvas-projects" activeClassName="is-active">画布管理</NavLink>
      <NavLink exact to="/admin/points-campaigns" activeClassName="is-active">活动管理</NavLink>
    </nav>
  );
}

export default AdminSectionNav;
